<!--
 * @Descripttion: 注册页面组件（已移除极验验证码）
 * @Author: congz
 * @Date: 2020-06-11 10:01:19
 * @LastEditors: congz
 * @LastEditTime: 2020-08-18 19:58:16
-->

<template>
  <div class="register">
    <div>
      <!-- 卡片组件，带悬浮阴影 -->
      <el-card class="box-card" shadow="hover">
        <!-- 卡片头部，显示“注册”标题 -->
        <div slot="header" class="clearfix">
          <span>注册</span>
        </div>
        <!-- 表单及注册按钮区域 -->
        <div class="item">
          <!-- 表单绑定数据模型和验证规则 -->
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <!-- 昵称输入项 -->
            <el-form-item prop="nickname">
              <el-input v-model="form.nickname" placeholder="昵称"></el-input>
            </el-form-item>
            <!-- 用户名输入项 -->
            <el-form-item prop="user_name">
              <el-input v-model="form.user_name" placeholder="用户名"></el-input>
            </el-form-item>
            <!-- 密码输入项 -->
            <el-form-item prop="password">
              <el-input v-model="form.password" placeholder="密码" type="password"></el-input>
            </el-form-item>
            <!-- 确认密码输入项 -->
            <el-form-item prop="password_confirm">
              <el-input v-model="form.password_confirm" placeholder="确认密码" type="password"></el-input>
            </el-form-item>
          </el-form>
          <!-- 验证码容器已移除（原极验验证码） -->
          <!-- 注册按钮，点击触发注册方法 -->
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient blue block" @click="register('form')">注册</a>
          </div>
          <!-- 跳转到登录页面的链接 -->
          <el-link type="primary" href="/#/login" style="float:right;margin-bottom:20px;">已有账号？直接登录></el-link>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
// 引入用户API模块
import * as userAPI from '@/api/users'

export default {
  name: 'Register',
  data() {
    // 自定义昵称验证规则
    var validateNick = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入昵称'))
      } else if (value.length < 2 || value.length > 10) {
        callback(new Error('昵称长度需在2到10之间'))
      }
      callback() // 验证通过
    }
    // 自定义用户名验证规则
    var validateUser = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入用户名'))
      } else if (value.length < 5 || value.length > 15) {
        callback(new Error('用户名长度需在5到15之间'))
      }
      callback()
    }
    // 自定义密码验证规则
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (value.length < 8 || value.length > 16) {
        callback(new Error('密码长度需在8到16之间'))
      } else {
        // 当密码发生变化时，若确认密码字段非空则重新校验确认密码
        if (this.form.password_confirm !== '') {
          this.$refs.form.validateField('password_confirm')
        }
        callback()
      }
    }
    // 自定义确认密码验证规则（需与密码一致）
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      imageUrl: '', // 预留字段，可用于头像等
      // 表单数据模型（已移除 challenge, validate, seccode）
      form: {
        nickname: '',
        user_name: '',
        password: '',
        password_confirm: ''
      },
      // 表单验证规则
      rules: {
        nickname: [{ validator: validateNick, trigger: 'blur' }], // 失去焦点时验证昵称
        user_name: [{ validator: validateUser, trigger: 'blur' }], // 失去焦点时验证用户名
        password: [{ validator: validatePass, trigger: 'blur' }],  // 失去焦点时验证密码
        password_confirm: [{ validator: validatePass2, trigger: 'blur' }] // 失去焦点时验证确认密码
      }
    }
  },
  methods: {
    /**
     * 注册方法（已移除极验验证码校验）
     * @param {string} formName - 表单引用名称
     */
    register(formName) {
      // 先触发表单整体验证
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return // 验证不通过则终止注册
        }
        // 直接调用注册API，不再验证极验验证码
        userAPI
          .postUser(this.form)
          .then(res => {
            if (res.status === 404) {
              // 后端返回404表示验证失败（可能业务逻辑）
              this.notifyError('验证失败', res.msg)
            } else if (res.status === 200) {
              // 注册成功，弹出成功提示并跳转到登录页
              this.notifySucceed('注册成功')
              this.$router.push({
                name: 'Login'
              })
            } else {
              // 其他状态码视为注册失败
              this.notifyError('注册失败', res.msg)
            }
          })
          .catch(error => {
            // 网络或服务器错误
            this.notifyError('注册失败', error)
          })
      })
    }
    // init_geetest 方法已移除，mounted中不再初始化验证码
  },
  mounted() {
    // 无需初始化验证码
  },
  components: {} // 未注册子组件
}
</script>

<style scoped>
/* 引入自定义按钮样式 */
@import '../assets/css/button.css';

/* 基础文字样式（保留） */
.text {
  font-size: 14px;
}

/* 表单项容器，固定宽度居中 */
.item {
  margin: 0 auto;
  width: 300px;
}

/* 卡片头部样式 */
.clearfix {
  font-size: 20px;
}

/* 卡片整体样式：居中、圆角、内外边距 */
.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 200px;
  border-radius: 10px;
}
</style>